import { ITrainingBlocks } from "../../../../models/master/training";
import { baseURL } from "../../../../constants/commonConstants";
import { IStaffEmployeeTrainingRegister } from "../../../../models/staff/employeeTraining";
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import {
  getTrainingBlocks,
  updateTrainingRegisterAndAttend,
} from "../../../../action/masters/trainingActionCreator";
import TrainingDetails from "./employeeTrainingModal/trainingDetails";
import { setTrainigBlocks } from "../../../../store/slices/master/trainingBlockSlice";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import ReactModal from "react-modal";
import moment from "moment";
import { format } from "date-fns";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const EmployeeTraining = (props: IStaffEmployeeTrainingRegister) => {
  const {
    getTrainingBlocks,
    trainingBlocks,
    snapShots,
    updateTrainingRegisterAndAttend,
  } = props;
  const [showDetail, setShowDetail] = useState(false);
  const [trainingDetail, setTrainingDetail] = useState<
    ITrainingBlocks | undefined
  >(undefined);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedId, setselectedId] = useState(0);

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.trainingBlocks);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getTrainingBlocks(pageBlockId.trainingBlocks, limit.three);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setTrainigBlocks([]));
    };
  }, []);

  const convertedDateTime = (date: any) => {
    const reversedDate = moment.utc(date).local().format("hh:mm A");
    return reversedDate;
  };

  const handleViewALL = () => {
    navigate(ROUTER_URL.STAFF_ALL_EMPLOYEE_TRAINING);
  };

  useEffect(() => {
    setTrainingDetail(
      trainingBlocks?.find(
        (trainingBlock: any) => trainingBlock.id === selectedId
      )
    );
  }, [selectedId, trainingBlocks]);

  const handleShow = () => setShowDetail(true);

  const handleClose = () => setShowDetail(false);

  const trainingRegisterOrAttend = async (id: number, link: string) => {
    const validUrl = /^(http|https):\/\//.test(link) ? link : `https://${link}`;
    window.open(validUrl, "_blank");
    await updateTrainingRegisterAndAttend(id);
    getTrainingBlocks(pageBlockId.trainingBlocks, limit.three);
  };

  return (
    <>
      <div className="card-wrap">
        <div className="title mb-28">
          <h2>Employee Training</h2>
          <a
            onClick={handleViewALL}
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All Employee Training"
          >
            View All
          </a>
        </div>
        <div className="row staff-training-list">
          {trainingBlocks
            ?.filter(
              (trainingblockitem: ITrainingBlocks) =>
                !trainingblockitem.isCompleted
            )
            .map((trainingblockitem: ITrainingBlocks) => (
              <div className="col-lg-12 mb-3">
                <div className="training-card">
                  <div className="trainingdtls">
                    <div className="img">
                      <img src={baseURL + trainingblockitem.image} alt="" />
                    </div>
                    <div className="desc">
                      <h6>{trainingblockitem.trainingCategory}</h6>
                      <p className="fw-semibold">{trainingblockitem.name}</p>
                      <p className="para-hide-2">
                        {trainingblockitem.description}
                      </p>
                      {/* <p>
                      {convertedDateTime(trainingblockitem?.trainingDate)}
                      {trainingblockitem?.endDate ? convertedDateTime(trainingblockitem?.endDate) : ""}
                    </p> */}
                      <p>
                        {trainingblockitem.trainingDate &&
                          format(trainingblockitem.trainingDate, "MM-dd-yyyy")}
                        {trainingblockitem.endDate &&
                          ` - ${format(
                            trainingblockitem.endDate,
                            "MM-dd-yyyy"
                          )}`}
                      </p>
                    </div>
                  </div>

                  <div className="btn-flex justify-content-between mt-2 border-top">
                    <div className="btn-flex justify-content-start gap-1">
                      <button
                        type="button"
                        className={
                          trainingblockitem.isMandatory
                            ? "btn-icon-border btn-tooltip tran-mandaroty active"
                            : "btn-icon-border btn-tooltip tran-mandaroty"
                        }
                        data-tooltip="Mandatory Training"
                        data-tooltip-pos="up"
                      >
                        <span>
                          <i className="fa-solid fa-star"></i>
                        </span>
                      </button>
                      <button
                        type="button"
                        className={
                          trainingblockitem.isAttendInPerson
                            ? "btn-icon-border btn-tooltip tran-inperson active"
                            : "btn-icon-border btn-tooltip tran-inperson"
                        }
                        data-tooltip="In-Person Training"
                        data-tooltip-pos="up"
                      >
                        <span>
                          <i className="fa-solid fa-user"></i>
                        </span>
                      </button>
                      <button
                        type="button"
                        className={
                          trainingblockitem.isOnline
                            ? "btn-icon-border btn-tooltip tran-online active"
                            : "btn-icon-border btn-tooltip tran-online"
                        }
                        data-tooltip="Online Training"
                        data-tooltip-pos="up"
                      >
                        <i className="fa-solid fa-desktop"></i>
                      </button>
                    </div>
                    <div className="btn-flex justify-content-end gap-2">
                      {trainingblockitem.isRegistered ? (
                        <button
                          className="btn btn-small btn-danger"
                          onClick={() =>
                            trainingRegisterOrAttend(
                              trainingblockitem.id,
                              trainingblockitem.linkToAttendTraining
                            )
                          }
                        >
                          Attend
                        </button>
                      ) : (
                        <button
                          className="btn btn-small btn-primary"
                          onClick={() =>
                            trainingRegisterOrAttend(
                              trainingblockitem.id,
                              trainingblockitem.linkToRegister
                            )
                          }
                        >
                          Register
                        </button>
                      )}

                      <button
                        className="btn btn-small btn-secondary"
                        data-bs-toggle="modal"
                        data-bs-target="#training-details"
                        onClick={() => {
                          handleShow();
                          setselectedId(trainingblockitem.id);
                        }}
                      >
                        View More
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <ReactModal
        isOpen={showDetail}
        onRequestClose={handleClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <TrainingDetails
          setShowEmployeeTraining={handleClose}
          trainingHelp={trainingDetail}
        />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getTrainingBlocks: (pageBlockId?: number, noOfItems?: number) =>
    getTrainingBlocks(pageBlockId, noOfItems),
  updateTrainingRegisterAndAttend: (id: number) =>
    updateTrainingRegisterAndAttend(id),
};

function mapStateToProps(state: any) {
  return {
    trainingBlocks: state.trainingBlock.trainingBlocks,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTraining);
